import { Reveal } from "./Reveal";
import type { StatItem } from "@/hooks/useHomeSettings";

const defaultStats: StatItem[] = [
  { value: "100+", label: "Hospital Beds" },
  { value: "12+", label: "Specialities" },
  { value: "50+", label: "Expert Doctors" },
  { value: "24/7", label: "Emergency Care" },
  { value: "50K+", label: "Patients Served" },
];

export function Stats({ items }: { items?: StatItem[] | null }) {
  const stats = items && items.length > 0 ? items : defaultStats;

  return (
    <section className="border-y border-border bg-surface py-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap justify-between gap-y-8">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 80} className="text-center">
              <div className="font-display text-4xl font-semibold text-primary md:text-5xl">
                {s.value}
              </div>
              <div className="mt-2 text-sm uppercase tracking-wider text-muted-foreground">
                {s.label}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
